import { Meaning } from '../interfaces';
import getChoiceMeaning from './get_choice_meaning';

export default (choice?: string): boolean => {
    return getChoiceMeaning(choice) === Meaning.MINUS;
};
